import { hideSameRowDuplicateEvents } from 'src/helpers/eventListHelpers';
import { Fragment, useState } from 'react';
import ListItem from './ListItem';
import { usePluginConfig } from '../../../contexts/pluginContext';
import ListPromotionalAsset from '../../atoms/ListPromotionalAsset';
import { getRandomIntInclusive } from '../../../utils/random';
import { createListWithAds } from '../../../utils/adHelper';
import { exists } from '../../../utils/objects';
const EventListPage = ({ events, pageNumber, forceAdPosition, featuredEvents }) => {
  const pluginConfig = usePluginConfig();
  const frameConfig = pluginConfig.frameConfig;
  const publisherSettings = pluginConfig.publisherSettings;
  const publisher = publisherSettings.publisher;
  const displayImagesOnBackfill = frameConfig?.options?.d_backfill_images;

  // We don't want to display the ad in the first two positions or in the last one.
  const [adPosition] = useState(
    forceAdPosition != null ? forceAdPosition : getRandomIntInclusive(2, events.length - 1)
  );

  const shouldDisplayAd = () => {
    return (
      events.length > 2 &&
      publisherSettings?.publisher?.promotional_assets?.some(
        (asset) => asset.asset_unit === 'event_list'
      )
    );
  };

  const listWithAds = createListWithAds(events, (exists(adPosition) && shouldDisplayAd()) ? [adPosition] : []);

  return (
    <div
      className="event-list-page contents"
      data-page-number={pageNumber}
      data-testid={`event-list-page-${pageNumber}`}
    >
      {events.length > 0 &&
        listWithAds.map((listElement, index) => (
          <Fragment key={`event-list-item-${index}`}>
            {listElement.isAd && (
              <ListPromotionalAsset
                utmSource={publisher.id}
                utmMedium="listings"
                utmCampaign="promote_asset"
              />
            )}
            {!listElement.isAd && (
              <ListItem
                event={listElement.event}
                position={{ pageNumber: pageNumber, index: index }}
                isFeatured={listElement.event.isFeatured(publisherSettings.publisher.id)}
                isEditorsPick={listElement.event.isEditorsPick(publisherSettings.publisher.id)}
                extraClasses={hideSameRowDuplicateEvents(listElement.event, featuredEvents || [], index)}
                isBackfill={listElement.event.isBackfill}
                displayImagesOnBackfill={displayImagesOnBackfill}
                viewedFrom="event_list"
                />
            )}
          </Fragment>
        ))}
    </div>
  );
};

export default EventListPage;
